import { render, staticRenderFns } from "./ReportStatusesWidget.vue?vue&type=template&id=a0eb1ef0&scoped=true&"
import script from "./ReportStatusesWidget.vue?vue&type=script&lang=js&"
export * from "./ReportStatusesWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatusesWidget.vue?vue&type=style&index=0&id=a0eb1ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb1ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0eb1ef0')) {
      api.createRecord('a0eb1ef0', component.options)
    } else {
      api.reload('a0eb1ef0', component.options)
    }
    module.hot.accept("./ReportStatusesWidget.vue?vue&type=template&id=a0eb1ef0&scoped=true&", function () {
      api.rerender('a0eb1ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportStatusesWidget.vue"
export default component.exports